import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRegisterParticipantGroupSchema from './RegisterParticipantGroup.schema';
import { buildTimeZoneOptions } from 'basics/options/timezone.options';
import { Market, Presence } from 'generated/event.types';
import eventLocaleOptions from 'modules/events/basics/options/eventLocale.options';
import { RegisterParticipantGroupConfigType } from 'modules/events/groups/RegisterParticipantGroup/RegisterParticipantGroup.types';

const useRegisterParticipantGroupConfig = (market = '') => {
  const { t } = useTranslation();
  const timezoneOptions = buildTimeZoneOptions();
  const [isPrivilegedParticipant, setIsPrivilegedParticipant] = useState(false);
  const [isPriviligedParticipantDisabled, setIsPriviligedParticipantDisabled] = useState(false);
  const joiningChannelOptions = [
    { id: Presence.online, label: Presence.online },
    { id: Presence.physical, label: Presence.physical },
  ];
  const registerParticipantSchema = useRegisterParticipantGroupSchema();
  const multiLanguageOptions = market ? eventLocaleOptions(market as Market) : [];

  const registerParticipantGroup: RegisterParticipantGroupConfigType = {
    participantMdmid: {
      label: t('event_register_participant_mdmid_label'),
      name: 'participantMdmid',
      placeholder: t('event_register_participant_mdmid_placeholder'),
      required: true,
      validation: registerParticipantSchema.participantMdmid,
    },
    participantTimezone: {
      label: t('event_register_participant_timezone_label'),
      name: 'participantTimezone',
      placeholder: t('event_register_participant_timezone_placeholder'),
      options: timezoneOptions,
      required: true,
      defaultValue: '',
      validation: registerParticipantSchema.participantTimezone,
    },
    participantMobilePhoneNumber: {
      label: t('event_register_participant_mobile_phone_number_label'),
      name: 'participantMobilePhoneNumber',
      placeholder: t('event_register_participant_mobile_phone_number_placeholder'),
      required: false,
      defaultValue: '',
      validation: registerParticipantSchema.participantMobilePhoneNumber,
    },
    participantJoiningChannel: {
      label: t('event_register_participant_joining_channel_label'),
      name: 'participantJoiningChannel',
      placeholder: t('event_register_participant_joining_channel_placeholder'),
      options: joiningChannelOptions,
      required: true,
      defaultValue: '',
      validation: registerParticipantSchema.participantJoiningChannel,
    },
    isPrivilegedParticipant: {
      label: t('event_register_participant_is_priviliged_label'),
      name: 'isPrivilegedParticipant',
      checked: isPrivilegedParticipant,
      disabled: isPriviligedParticipantDisabled,
    },
    participantSelectedMultiLanguage: {
      label: t('event_register_participant_selected_multi_language_field_label'),
      name: 'participantSelectedMultiLanguage',
      placeholder: t('event_register_participant_selected_multi_language_field_placeholder'),
      options: multiLanguageOptions,
      required: true,
      defaultValue: multiLanguageOptions[0]?.id,
      validation: registerParticipantSchema.participantSelectedMultiLanguage,
      disableClearable: true,
    },
  };

  return {
    registerParticipantGroup,
    setIsPrivilegedParticipant,
    setIsPriviligedParticipantDisabled,
  };
};

export default useRegisterParticipantGroupConfig;
